//export const BAR_COLORS = ['#548400', '#5a8e00', '#639b00', '#69a501', '#76b900', '#7ac100', '#80c900', '#90e200', ]
export const BAR_COLORS = ['#76b900']
export const LINE_COLOR_2 = '#00afb9'
export const REFERENCE_LINE_COLOR = '#c1c1c1'
export const REFERENCE_LINE_WIDTH = 2
export const CHART_HEIGHT = 350
